import { Injectable } from "@angular/core";
import { removeEmpty } from "@dmms/shared/utils/functions";
import { HardStringUtils } from "@hardcode-kz/ui";
import { IApiResponse, IBaseHttpResponse } from "@models/http/http-options";
import { Observable } from "rxjs";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class DictionaryService extends BaseService {
  getAll<T = any>(dicType: string, version = 1, params?: any): Observable<T> {
    removeEmpty(params);
    return this.get(`v${version}/${dicType}`, params);
  }

  getAllByPost<T = any>(
    dicType: string,
    version = 1,
    params?: any,
  ): Observable<T> {
    return this.post(`v${version}/${dicType}`, params);
  }

  getAllMinimal(dicType: string, version = 1, params?: any): Observable<any> {
    removeEmpty(params);
    return this.get(`v${version}/${dicType}/minimal`, params);
  }

  getItem(
    dicType: string,
    id: string,
    version = 1,
  ): Observable<IApiResponse<any>> {
    return this.get(`v${version}/${dicType}/${id}`);
  }

  saveItem(
    dicType: string,
    data: any,
    version = 1,
  ): Observable<IBaseHttpResponse> {
    return this.post(`v${version}/${dicType}`, data);
  }

  updateItem(
    dicType: string,
    data: any,
    version = 1,
    method?: "POST" | "PUT" | "PATCH",
  ): Observable<IBaseHttpResponse> {
    if (method === "PATCH") {
      return this.patch(`v${version}/${dicType}/${data.id}`, data);
    }
    if (method === "POST") {
      return this.post(`v${version}/${dicType}`, data);
    }
    return this.put(`v${version}/${dicType}/${data.id}`, data);
  }

  duplicateItem(
    dicType: string,
    data: any,
    version = 1,
  ): Observable<IBaseHttpResponse> {
    return this.post(`v${version}/${dicType}/${data.id}`, data);
  }

  deleteItem(
    dicType: string,
    id: string,
    version = 1,
  ): Observable<IBaseHttpResponse> {
    return this.remove(`v${version}/${dicType}/${id}`);
  }

  restoreItem(
    dicType: string,
    id: string,
    version = 1,
  ): Observable<IBaseHttpResponse> {
    return this.http.put<IBaseHttpResponse>(
      `${this.apiUrl}v${version}/${dicType}/restore`,
      [id],
    );
  }

  replaceParamsUrl(dicType: string, params: any): string {
    let next = true;

    const urlParams = HardStringUtils.extractParamsFromUrl(dicType);

    if (urlParams?.length) {
      urlParams.forEach((param) => {
        if (!params[param]) {
          next = false;
        }
      });

      if (!next) {
        return "";
      }

      return HardStringUtils.replaceParamsInUrl(dicType, params);
    }

    return dicType;
  }
}
